import * as types from './types'

export const updateAddress = (address) => ({
  type: types.UPDATE_ADDRESS,
  payload: address,
})

export const switchToEditMode = () => ({
  type: types.EDIT_MODE,
})

export const switchToNewMode = () => ({
  type: types.NEW_MODE,
})

export const switchToListMode = () => ({
  type: types.LIST_MODE,
})

export const selectAddress = (id) => ({
  type: types.SELECT_ADDRESS,
  payload: id,
})

export const updateAllCountries = (countries) => ({
  type: types.UPDATE_ALL_COUNTRIES,
  payload: countries,
})

export const updateStates = (states) => ({
  type: types.UPDATE_STATES,
  payload: states,
})

export const toggleLoader = (state) => ({
  type: types.TOGGLE_LOADER,
  payload: state,
})

export const setInitialSelectedAddressID = (id) => ({
  type: types.SET_INITIAL_SELECTED_ADDRESS_ID,
  payload: id,
})

export const setSelectedAddressID = (id) => ({
  type: types.SET_SELECTED_ADDRESS_ID,
  payload: id,
})

export const resetAddress = () => ({
  type: types.RESET_ADDRESS,
})

export const onTextFieldChange = (event) => ({
  type: types.ON_TEXT_FIELD_CHANGE,
  payload: event,
})

export const onSelectChange = (value, field) => ({
  type: types.ON_SELECT_CHANGE,
  payload: {
    value,
    field,
  },
})

export const updateCountryCode = (code) => ({
  type: types.UPDATE_COUNTRY_CODE,
  payload: code,
})

export const setMerchantCountry = (country) => ({
  type: types.SET_MERCHANT_COUNTRY,
  payload: country,
})

export const resetState = () => ({
  type: types.RESET_STATES,
})

export const validateAllFields = () => ({
  type: types.VALIDATE_ALL_FIELDS,
})

export const showAddressFeedback = () => ({
  type: types.SHOW_ADDRESS_FEEDBACK,
})

export const hideAddressFeedback = () => ({
  type: types.HIDE_ADDRESS_FEEDBACK,
})

export const showDeleteAddressModal = () => ({
  type: types.SHOW_DELETE_ADDRESS_MODAL,
})

export const hideDeleteAddressModal = () => ({
  type: types.HIDE_DELETE_ADDRESS_MODAL,
})

export const showDeleteAddressError = (message) => ({
  type: types.SHOW_DELETE_ADDRESS_ERROR,
  payload: message,
})

export const clearDeleteErrorMessage = () => ({
  type: types.CLEAR_DELETE_ADDRESS_ERROR,
})

export const showAddAddressError = (message) => ({
  type: types.SHOW_ADD_ADDRESS_ERROR,
  payload: message,
})

export const clearAddAddressError = () => ({
  type: types.CLEAR_ADD_ADDRESS_ERROR,
})

export const clearValidationErrorMessage = () => ({
  type: types.CLEAR_VALIDATION_ERROR_MESSAGES,
})
